<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import IconDownload from "$components/Icons/IconDownload.svelte";
  let { onclick, label, isLoading = false } = $props();
</script>

<div class="button-container">
  <!-- button -->
  <button {onclick} disabled={isLoading}>
    {isLoading ? "Downloading..." : label}
    {#if !isLoading}
      <IconDownload />
    {/if}
  </button>
</div>

<style>
  .button-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  button {
    display: inline-flex;
    gap: var(--spacing-1);
    align-items: start;
    justify-content: start;
    color: var(--color-black);
    font-size: var(--font-size-normal);
    font-weight: var(--font-weight-bold);
    font-family: inherit;
    padding: 0;
    background-color: transparent;
    border: none;
  }

  button:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  button:disabled {
    cursor: default;
    opacity: 0.6;
  }

  button:disabled:hover {
    text-decoration: none;
  }
</style>
